export const noCacheHeaders = {
  'cache-control': 'no-cache',
  pragma: 'no-cache',
  expires: '0',
  'x-loaded-from': 'no-cache'
};

export const noCacheQueryOptions = {
  staleTime: 0,
  gcTime: 0,
  refetchOnMount: 'always'
};
